<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">会员风采</router-link></li>
                <li><router-link to="">城市风采</router-link></li>
                <li><router-link to="/layout/city-list">城市简介</router-link></li>
                <li class="currentNode"><a>城市详情</a></li>
            </ul>
            <div class="page-main">
                <h4>
                    <span>北京</span>
                    <!-- <span class="food-tag">有包间</span> -->
                </h4>
                <el-divider></el-divider>
               <div class="city-des">
                    <p>北京，简称“京”，是中华人民共和国的首都，是全国的政治中心、文化中心，是世界著名古都和现代化国际城市。北京位于北纬39度56分、东经116度20分，地处华北大平原的北部，东面与天津市毗连，其余均与河北省相邻。</p>
                    <div class="two-col">
                        <div class="first-col">
                            <img src="@/assets/image/index/office4.png" />
                        </div>
                        <div class="education">
                            <p class="title">科学教育及其他社会事业</p>
                            <p class="des-origin">数据来源:《北京市2023年国民经济和社会发展统计公报》(数据发时间:2024年3月21日)</p>
                            <p>
                                教育:2023年全年研究生教育招生15.2万人，在学研究生45.5万人，毕业生12.1万人。普通高等学校招收本专科学生17.6万人，在校生61.8万人，毕业生15.4万人。全市成人本专科招生3.0万人，在校生7.6万人，毕业生3.0万人。
2023年全年普通高中招生8.0万人，在校生21.7万人，毕业生5.9万人。普通初中招生13.5万人，在校生37.1万。  
                            </p>
                        </div>
                    </div>
                    <p>
                        北京，简称“京”，是中华人民共和国的首都，是全国的政治中心、文化中心，是世界著名古都和现代化国际城市。北京位于北纬39度56分、东经116度20分，地处华北大平原的北部，东面与天津市毗连，其余均与河北省相邻。
                    </p>
                    <div class="two-col city-plan-box">
                        <div class="city-plan">
                            <p class="title">城市建设</p>
                            <p class="des-origin">数据来源:《北京市2023年国民经济和社会发展统计公报》(数据发时间:2024年3月21日)</p>
                            <p>
                                教育:2023年全年研究生教育招生15.2万人，在学研究生45.5万人，毕业生12.1万人。普通高等学校招收本专科学生17.6万人，在校生61.8万人，毕业生15.4万人。全市成人本专科招生3.0万人，在校生7.6万人，毕业生3.0万人。  
                            </p>
                        </div>
                        <img src="@/assets/image/index/office4.png" class="city-plan-image" />
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getPlolicyDetail
} from '@services/indexService.js';

export default {
    name:"",
    data() {
        return {
            detailId: '',
            title: '',
            subTitle: '',
            tagList: [],
            createTime: '',
            imageUrl: '',
            tel: '',
            homeAddress:'',
            avgPrice: '',
            description: '',
            recommendationList: [],
        }
    },
    created() {
        this.detailId = this.$route.query.id;
        this.getPlolicyDetail(this.detailId +1);
    },
    methods: {
        getPlolicyDetail(id) {
            let params = {
                id: id
            };
            getPlolicyDetail(params).then(res => {
                console.log(res);
                if (res.Code === 1 && res.Data !== null && res.Data.length!==0) {
                    this.publishTime = res.Data.UpdateTime;
                    this.title = res.Data.Title;
                    this.subTitle = res.Data.SubTitle;
                    this.tagList = res.Data.lstSubTitle;
                    this.createTime = res.Data.CreateTime;
                    this.imageUrl = res.Data.ImageUrl;
                    this.tel = res.Data.Tel;
                    this.homeAddress = res.Data.HomeAddress;
                    this.avgPrice = res.Data.AvgPrice;
                    this.description = res.Data.Description;
                    this.recommendationList = res.Data.ListImage;
                } else {
                    this.$message.error("协会要问请求失败");
                }
            })

        },
        handleCurrentChange(pageNum) {

        }
    }
}
</script>

<style scoped>
.page-main{
    display: block;
    background: #fff;
    padding: 30px 56px;
    box-sizing: border-box;
}
.page-main h4 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #262626;
    font-size: 26px;
    margin-bottom: 20px;
}
.page-main h4 span:first-child {
    margin-right: 10px;
}
.city-des p{
    color: #4E5969;
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28px;
}
.two-col {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.first-col {
    position: relative;
    padding: 20px;
    padding-top: 0;
    margin-bottom: 20px;
}
.first-col img {
    position: relative;
    width: 456px;
    height: 254px;
    display: block;
    z-index: 5;
}
.first-col:after {
    content:"";
    width: 133px;
    height: 134px;
    background: #116EBA;
    position: absolute;
    bottom: 0;
    left: 0;
}
.des-origin {
    margin-bottom: 20px;
}
.education {
    width: 668px;
    height: 274px;
    box-sizing: border-box;
}
.city-des .title,
.city-plan .title{
    font-size: 18px;
    font-weight: bold;
    color: #262626;
    margin-bottom: 20px;
}
.city-plan .title {
    color: #fff;
}
.city-plan-box {
    background: #116EBA;
}
.city-plan {
    width: 690px;
    min-height: 267px;
    padding: 20px;
    box-sizing: border-box;

}
.city-plan p {
    color: #fff;
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28px;
}
.city-plan-image {
    display: block;
    width: 478px;
    height: 266px;
}
</style>